<template>
  <div v-if="isConfigured && hasContentLoaded" :class="['logon-wrapper d-flex align-items-center min-vh-100', { 'logon-wrapper-mobile': isMobile }]" :style="tenantcolor">
    <div class="container h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-12 text-center">
          <img v-if="tenantLogoURL" :src="tenantLogoURL" :alt="$t('auth.tenantLogoAlt')" class="tenant_logo" />
          <img v-else :src="commovisLogo" :alt="$t('common.commovisLogoAlt')" class="tenant_logo" />

          <div v-if="tenantdescription" class="tenant-description-wrap">
            <p ref="descriptionEl" class="tenant-description">{{ firstParagraph }}</p>
            <button v-if="isDescriptionClamped || hasMoreContent" class="tenant-description-more" @click="descriptionOpen = true">{{ $t('common.readMore') }}</button>
          </div>

          <Teleport to="body">
            <Transition name="desc-overlay">
              <div v-if="descriptionOpen" class="desc-overlay" @click.self="descriptionOpen = false">
                <div class="desc-overlay-card">
                  <button class="desc-overlay-close" @click="descriptionOpen = false" aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </button>
                  <div class="desc-overlay-header">
                    <div class="desc-overlay-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                    </div>
                    <span class="desc-overlay-title">{{ tenantname }}</span>
                  </div>
                  <div class="desc-overlay-divider"></div>
                  <p class="desc-overlay-text">{{ tenantdescription }}</p>
                </div>
              </div>
            </Transition>
          </Teleport>

          <Authenticator v-if="isConfigured && !isAuthenticated" :socialProviders="[]" :hideSignUp="true"  :formFields="formFields">
            <template v-slot="{ user, signOut }">
             <!--- <h1>Welcome {{ user.username }}!</h1>
              <button @click="signOut">Sign out</button> -->
            </template>
          </Authenticator>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, computed, onMounted, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useDevice } from '@/composables/useDevice'
import { Authenticator } from '@aws-amplify/ui-vue'
import { Hub } from '@aws-amplify/core'
//import { Amplify } from '@aws-amplify/core';
import '@aws-amplify/ui-vue/styles.css'
import commovisLogo from '@/assets/logo_long.png'
import { configAuthForLogin } from '@/services/auth'

export default {
  components: {
    Authenticator,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const { isMobile } = useDevice();
    const hasContentLoaded = ref(false);
    const isConfigured = ref(false);
    const descriptionOpen = ref(false);
    const descriptionEl = ref(null);
    const isDescriptionClamped = ref(false);


    const isAuthenticated = computed(() => store.state.auth.loggedIn);
    const tenantLogoURL = ref(null);
    const tenantname = computed(() => store.state.tenant.tenantinfo.title);
    const tenantdescription = computed(() => store.state.tenant.tenantinfo.description);
    const firstParagraph = computed(() => {
      const desc = tenantdescription.value || '';
      const idx = desc.indexOf('\n');
      return idx !== -1 ? desc.slice(0, idx) : desc;
    });
    const hasMoreContent = computed(() => {
      const desc = tenantdescription.value || '';
      const idx = desc.indexOf('\n');
      return idx !== -1 && desc.slice(idx + 1).trim().length > 0;
    });
    const tenantcolor = computed(() => ({
      '--primary-color': store.state.tenant.tenantinfo.primarycolor
    }));
    const tenantwelcome = computed(() => t('auth.signInTo', { tenant: tenantname.value }));

    const getTenantLogoURL = async() => {
      if (store.state.tenant.tenantinfo.logo) {
        tenantLogoURL.value = await store.dispatch('file/getTenantLogoFile');
      } else {
        tenantLogoURL.value = null;
      }
    };

    //console.log('isAuthenticated value check in Logon.vue:', isAuthenticated.value);
    if (isAuthenticated.value) {
      router.push({ name: isMobile.value ? 'MobileDashboard' : 'Dashboard' });
    }

    const formFields = computed(() => ({
      signIn: {
        username: {
          label: t('auth.email'),
          placeholder: t('auth.enterYourEmail'),
          isRequired: true,
          errorMessage: {
            empty: t('auth.emailRequired'),
            invalid: t('auth.invalidEmail'),
          },
        },
      }
    }));

    onMounted(async () => {
      await store.dispatch('tenant/getTenant');
      await configAuthForLogin(); // Configure Amplify for login

      isConfigured.value = true;
      
      await getTenantLogoURL();
      await store.dispatch('loading/setLoading', false);
      hasContentLoaded.value = true;
      await nextTick();
      if (descriptionEl.value) {
        isDescriptionClamped.value = descriptionEl.value.scrollHeight > descriptionEl.value.clientHeight;
      }
      

      Hub.listen('auth', (data) => {
    if (data.payload.event === 'signedIn') {
      const redirectRoute = router.currentRoute.value.query.redirect || (isMobile.value ? 'MobileDashboard' : 'Dashboard');
      router.push({ name: redirectRoute });
    }
  });
    });
     // Watch for changes in authentication status
     watch(isAuthenticated, (newValue) => {
     //console.log('isAuthenticated changed to:', newValue);
     // console.log('The user signed in now!');
     if (newValue) {
    const redirectRoute = router.currentRoute.value.query.redirect || (isMobile.value ? 'MobileDashboard' : 'Dashboard');
    router.push({ name: redirectRoute });
  }
    });

    return {
      tenantname,
      tenantdescription,
      descriptionOpen,
      descriptionEl,
      isDescriptionClamped,
      firstParagraph,
      hasMoreContent,
      tenantwelcome,
      tenantcolor,
      isAuthenticated,
      hasContentLoaded,
      tenantLogoURL,
      commovisLogo,
      isConfigured,
      formFields,
      isMobile,
    }
  }
}
</script>

<style lang="scss" scroped>
.logon-wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
 
  
}
.logon-wrapper-mobile{
    max-width: 100%;
    padding: 10px;
    border-radius: 0;
    width:90vw;
}

.tenant_logo {
  margin-top: 20px;
  margin-bottom: 5px;
  width: 100%;
  max-width: 380px;
}

.tenant-description-wrap {
  max-width: 30rem;
  margin: 10px auto;
}

.tenant-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #555;
  font-size: 0.92rem;
  line-height: 1.6;
  text-align: center;
  letter-spacing: 0.01em;
  font-style: italic;
  margin: 0;
}

.tenant-description-more {
  background: none;
  border: none;
  padding: 0;
  color: var(--primary-color);
  font-size: 0.8rem;
  cursor: pointer;
  opacity: 0.85;

  &:hover { opacity: 1; text-decoration: underline; }
}

.desc-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 24px;
}

.desc-overlay-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  padding: 28px 28px 32px;
  max-width: 460px;
  width: 100%;
  position: relative;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.desc-overlay-close {
  position: absolute;
  top: 14px;
  right: 14px;
  background: #f3f3f3;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;

  &:hover { background: #e8e8e8; color: #333; }
}

.desc-overlay-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-right: 36px;
}

.desc-overlay-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--primary-color) 12%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
}

.desc-overlay-title {
  font-size: 1rem;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}

.desc-overlay-divider {
  height: 1px;
  background: #f0f0f0;
  margin-bottom: 18px;
  flex-shrink: 0;
}

.desc-overlay-text {
  margin: 0;
  color: #555;
  font-size: 0.92rem;
  line-height: 1.75;
  text-align: left;
  white-space: pre-line;
  overflow-y: auto;
  font-style: italic;
}

.desc-overlay-enter-active {
  transition: opacity 0.2s ease;
  .desc-overlay-card { transition: transform 0.2s ease; }
}
.desc-overlay-leave-active {
  transition: opacity 0.15s ease;
}
.desc-overlay-enter-from,
.desc-overlay-leave-to {
  opacity: 0;
  .desc-overlay-card { transform: translateY(10px) scale(0.98); }
}


// Custom styles for Amplify UI components
:root {
  --amplify-colors-brand-primary-10: var(--primary-color);
  --amplify-colors-brand-primary-80: var(--primary-color);
  --amplify-colors-brand-primary-90: var(--primary-color);
  --amplify-colors-brand-primary-100: var(--primary-color);
  --amplify-components-button-primary-background-color: var(--primary-color);
  --amplify-components-button-primary-hover-background-color: var(--primary-color);
  --amplify-components-button-primary-focus-background-color: var(--primary-color);
}

.amplify-authenticator {
  --amplify-colors-background-secondary: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
  overflow: hidden;

 
 

}


.amplify-button[data-variation='primary'] {
  background-color: var(--primary-color) ;
  border-color: var(--primary-color) ;
}
.amplify-button[data-variation='primary']:hover,
.amplify-button[data-variation='primary']:focus {
  background-color: var(--primary-color);
  opacity: 0.9;
}

.amplify-button[data-variation='link'] {
  //background-color: var(--primary-color) !important;
  color: var(--primary-color) ;
}
.amplify-button[data-variation='link']:hover,
.amplify-button[data-variation='link']:focus {
  color:#ffffff ;
  background-color: var(--primary-color);
  opacity: 0.2;
}




.amplify-input {
  border-color: #ccc;
}

.amplify-input:focus {
  border-color: var(--primary-color) !important;
}


</style>